import { SAVE_SIDENAV_SEARCH_TEXT, SIDENAV_SUB_MENU } from '../actions/SidenavActions';

const initialState = {
  searchText: '',
  isSubMenu: false,
};

export default function SidenavReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_SIDENAV_SEARCH_TEXT:
      return { ...state, searchText: action.searchText };
    case SIDENAV_SUB_MENU:
      return { ...state, isSubMenu: action.isSubMenu };
    default:
      return state;
  }
}
